import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VehiclesPage from "../pages/vehicles/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vehicles",
    element: <VehiclesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;